import { Injectable } from '@angular/core';
import { ApiClientService } from './common/api-client.service';
import { CarrierContactAssoc, CarrierDomain, InsertArchiveCarrierDomain, InsertCarrierFieldConfiguration } from '../models/packages/carrierContactAssoc.model';
import { ContactModel } from '../models/packages/contact.model';
import { ActivityHistory, Package, PackageAttachment, PackageDetailHeader, PackageDetailLineItem, PackageDetailNote, PackageNote, PackageProcessStatus, SearchPackage } from '../models/packages/package.model';
import { SearchProducerRequest } from '../models/packages/searchProducerRequest.model';
import { VerifyGuestUserRequest } from '../models/packages/verifyGuestUserRequest.model';
import { CompletePackageRequest } from '../models/packages/completePackageRequest.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';
import { RoleService } from 'services/role.service';
import { PackageRequestFees, ParticipatingCarrier } from '../models/packages/participating-carrier.model';
import { UpdatePackageDetailStatusRequest } from '../models/packages/update-package-detail-status-request.model';
import { SearchPackageReport } from '../models/packages/search-package-report.model';
import { CarrierDocumentTemplate } from '../models/packages/carrier-document-template.model';
import { DocumentSubmission, PackageRequiredStatus } from '../models/packages/document-submission.model';
import { DocumentType } from 'models/packages/document-type.model';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PackageService {
  
  constructor(
    private apiClient: ApiClientService, private http: HttpClient, private roleService: RoleService) { }

  getCarrierContactAssoc(searchName: string) {
    return this.apiClient.get(`api/package/getCarrierContactAssoc/${searchName}`, null, null, true);
  }

  insertCarrierContact(contact: ContactModel) {
    return this.apiClient.post(`api/package/insertCarrierContact`, contact, null, true);
  }

  updateCarrierContact(contact: ContactModel) {
    return this.apiClient.post(`api/package/updateCarrierContact`, contact, null, true);
  }

  makeDefaultContact(contact: ContactModel) {
    return this.apiClient.post(`api/package/makeDefaultContact`, contact, null, true);
  }

  deleteCarrierContact(contactId: number) {
    return this.apiClient.post(`api/package/deleteCarrierContact/${contactId}`, null, null, true);
  }

  getActivePackages(searchPackage: SearchPackage) {
    // if (searchName != null) {
    //   return this.apiClient.get(`api/package/getActivePackages/${searchName}`, null, null, true);
    // }
    // else {
      return this.apiClient.post(`api/package/getActivePackages`, searchPackage, null, true);
    //}
  }

  getArchivePackages(searchPackage: SearchPackage) {
    // if (searchName != null) {
    //   return this.apiClient.get(`api/package/getArchivePackages/${searchName}`, null, null, true);
    // }
    // else {
      return this.apiClient.post(`api/package/getArchivePackages`, searchPackage, null, true);
    //}
  }

  getPackageDetail(packageId: number, showLoader: boolean = true) {    
    return this.apiClient.get(`api/package/getPackageDetail/${packageId}`, null, null, showLoader);

  }

  insertPackage(packageObj: Package) {
    return this.apiClient.post(`api/package/insertPackage`, packageObj, null, true);
  }

  getPackageNotes(packageDetailId: number, guestUser: boolean = false) {      
    if(guestUser == false)
      return this.apiClient.get(`api/package/getPackageNotes/${packageDetailId}`, null, null, false);
    else 
      return this.apiClient.get(`api/packageguestuser/getPackageNotesForCarrier/${packageDetailId}`, null, null, false);
  }

  insertPackageNote(packageNote: PackageDetailNote) {
    if(packageNote.GuestUser == false)
      return this.apiClient.post(`api/package/insertPackageNote`, packageNote, null, false);
    else  
      return this.apiClient.post(`api/packageguestuser/insertPackageNoteForCarrier`, packageNote, null, false);
  }

  insertPackageAttachment(packageAttachment: PackageAttachment) {
    return this.apiClient.post(`api/package/insertPackageAttachment`, packageAttachment, null, true);
  }

  searchProducer(request: SearchProducerRequest) {
    return this.apiClient.post(`api/package/searchProducer`, request, null, true);
  }

  searchProducerAppointment(request: SearchProducerRequest) {
    return this.apiClient.post(`api/package/searchProducerAppointment`, request, null, true);
  }

  updatePackage(packageObj: Package, showLoading: boolean = true) {
    return this.apiClient.post(`api/package/updatePackage`, packageObj, null, showLoading);
  }

  archivePackage(packageId: number) {
    return this.apiClient.post(`api/package/archivePackage/${packageId}`, null, null, true);
  }

  deletePackage(packageId: number) {
    return this.apiClient.post(`api/package/deletePackage/${packageId}`, null, null, true);
  }

  getActiveLicenesList() {
    return this.apiClient.get(`api/package/getActiveLicenseList`, null, null, true);
  }

  getStates(carrierId: number = null) {
    if (carrierId != null) {
      return this.apiClient.get(`api/package/getStates/${carrierId}`, null, null, true);
    }
    else {
      return this.apiClient.get(`api/package/getStates`, null, null, true);
    }
  }

  getActiveLOAList(carrierId: number = null) {
    if (carrierId != null) {
      return this.apiClient.get(`api/package/getActiveLOAList/${carrierId}`, null, null, true);
    }
    else {
      return this.apiClient.get(`api/package/getActiveLOAList`, null, null, true);
    }
  }

  getCarrierPackageContactByCarrierId(carrierId: number, showLoading: boolean = true) {
    return this.apiClient.get(`api/package/getCarrierPackageContactByCarrierId/${carrierId}`, null, null, showLoading);
  }

  sendPackage(packageId: number) {
    return this.apiClient.post(`api/package/sendPackage/${packageId}`, null, null, true);
  }

  sendVerificationCode(activateUrl: string) {
    var contact = {} as ContactModel;
    contact.activateUrl = activateUrl;
    return this.apiClient.post(`api/packageguestuser/sendVerificationCode`, contact, null, true);
  }

  verifyGuestUser(verifyRequest: VerifyGuestUserRequest) {
    return this.apiClient.post(`api/packageguestuser/verifyGuestUser`, verifyRequest, null, true);
  }

  setPwd(setPwdObj: any) {
    return this.apiClient.post(`api/packageguestuser/setpassword`, setPwdObj, null, true);
  }

  getPackagesForCarrierUser(searchName: string = null) {
    if (searchName != null) {
      return this.apiClient.get(`api/packagecarrier/getPackages/${searchName}`, null, null, true);
    }
    else {
      return this.apiClient.get(`api/packagecarrier/getPackages`, null, null, true);
    }
  }

  getPackagesForGuestUser(searchName: string = null) {
    if (searchName != null) {
      return this.apiClient.get(`api/packageguestuser/getPackages/${searchName}`, null, null, true);
    }
    else {
      return this.apiClient.get(`api/packageguestuser/getPackages`, null, null, true);
    }
  }

  getPackageDetailForCarrierUser(packageId: number, showLoading: boolean = true) {
    return this.apiClient.get(`api/packagecarrier/getPackageDetails/${packageId}`, null, null, showLoading);

  }

  getPackageDetailForGuestUser(packageId: number) {
    return this.apiClient.get(`api/packageguestuser/getPackageDetails/${packageId}`, null, null, true);

  }

  getContactByEmail(contact: ContactModel) {
    return this.apiClient.post(`api/package/getContactByEmail`, contact, null, true);
  }

  getCarrierFieldConfiguration(carrierId: number) {
    return this.apiClient.get(`api/package/getCarrierFieldConfiguration/${carrierId}`, null, null, true);
  }

  insertCarrierFieldConfiguration(insertCarrierField: InsertCarrierFieldConfiguration) {
    return this.apiClient.post(`api/package/insertCarrierFieldConfiguration`, insertCarrierField, null, true);
  }

  getCarrierDomains(carrierId: number) {
    return this.apiClient.get(`api/package/getCarrierDomains/${carrierId}`, null, null, true);
  }

  insertCarrierDomain(insertCarrierDomain: InsertArchiveCarrierDomain) {
    return this.apiClient.post(`api/package/insertCarrierDomain`, insertCarrierDomain, null, true);
  }

  archiveCarrierDomain(archiveCarrierDomain: InsertArchiveCarrierDomain) {
    return this.apiClient.post(`api/package/archiveCarrierDomain`, archiveCarrierDomain, null, true);
  }

  completePackage(isGuestUser: boolean, formData: FormData) {
    const header = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    if (isGuestUser) {
      return this.apiClient.uploadFile(`api/packageguestuser/completePackage`, formData, header);
    }
    else {
      return this.apiClient.uploadFile(`api/packagecarrier/completePackage`, formData, header);
    }
  }

  inprogressPackage(isGuestUser: boolean, completedPackageRequest: CompletePackageRequest) {
    if (isGuestUser) {
      return this.apiClient.post(`api/packageguestuser/inprogressPackage`, completedPackageRequest, null, true);
    }
    else {
      return this.apiClient.post(`api/packagecarrier/inprogressPackage`, completedPackageRequest, null, true);
    }
  }

  getPackageDetailForReview(packageId: number) {
    return this.apiClient.get(`api/package/getPackageDetailForReview/${packageId}`, null, null, true);

  }

  updateRecipient(packageObj: Package) {
    return this.apiClient.post(`api/package/updateRecipient`, packageObj, null, true);
  }

  uploadAttachments(packageId, formData: FormData, packageDetailId = undefined, carrierUser: boolean = false, isGuestUser: boolean = false): Observable<any> {
    const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    var controller = this.getControllerName(carrierUser, isGuestUser);
    var action = "uploadPackageAttachments";

    var requestUrl = environment.baseUrl + `api`;
    if (packageDetailId != undefined) {
      action = "uploadPackageDetailAttachments";
      requestUrl = `${requestUrl}/${controller}/${action}/${packageId}/${packageDetailId}`
    }
    else {
      requestUrl = `${requestUrl}/${controller}/${action}/${packageId}`
    }

    return this.http.post(requestUrl, formData, {
      headers: headers,
      reportProgress: true
    });
  }

  public downloadPackageFile(packageAttachmentId, carrierUser: boolean = false, isGuestUser: boolean = false) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    var controller = this.getControllerName(carrierUser, isGuestUser);
    var requestUrl = environment.baseUrl + `api/${controller}/downloadPackageFile/${packageAttachmentId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }

  public deletePackageAttachment(packageAttachmentId, carrierUser: boolean = false, isGuestUser: boolean = false) {
    var controller = this.getControllerName(carrierUser, isGuestUser);
    var requestUrl = `api/${controller}/deletePackageAttachment/${packageAttachmentId}`;
    return this.apiClient.delete(requestUrl, null, null, true);
  }

  getControllerName(carrierUser: boolean, isGuestUser: boolean) {
    var controller: string = "package";
    if (carrierUser) {
      if (isGuestUser) {
        controller = "packageguestuser";
      }
      else {
        controller = "packagecarrier";
      }
    }
    return controller;
  }

  public archivePackageAttachment(packageAttachmentId, carrierUser: boolean = false, isGuestUser: boolean = false) {
    var controller = this.getControllerName(carrierUser, isGuestUser);
    var requestUrl = `api/${controller}/archivePackageAttachment/${packageAttachmentId}`;

    return this.apiClient.post(requestUrl, null, null, true);
  }

  public unarchivePackageAttachment(packageAttachmentId, carrierUser: boolean = false, isGuestUser: boolean = false) {
    var controller = this.getControllerName(carrierUser, isGuestUser);
    var requestUrl = `api/${controller}/unarchivePackageAttachment/${packageAttachmentId}`;

    return this.apiClient.post(requestUrl, null, null, true);
  }

  getPackageAttachments(packageId: number, archive: boolean, packageDetailId: number = undefined, carrierUser: boolean = false, isGuestUser: boolean = false) {
    var controller = this.getControllerName(carrierUser, isGuestUser);
    var requestUrl = `api/${controller}/getPackageAttachments/${packageId}/${archive}`;

    if (packageDetailId != null) {
      requestUrl = `api/${controller}/getPackageAttachments/${packageId}/${archive}/${packageDetailId}`;
    }

    return this.apiClient.get(requestUrl, null, null, false);
  }

  getPackageActivityHistory(packageId: number, isChat: number | null, guestUser: boolean = false) {    
    let url;
    if(guestUser == false)
    {
      url = `api/package/getPackageActivityHistory/${packageId}/${this.roleService.isCarrierUser}`;
      if (isChat !== null) {
        url += `/${isChat}`;
      }
    } else{
      url = `api/packageguestuser/getPackageActivityHistoryForCarrier/${packageId}/true`;
      if (isChat !== null) {
        url += `/${isChat}`;
      }
    }
    return this.apiClient.get(`${url}`, null, null, false);
    // if(guestUser == false)
    //   return this.apiClient.get(`api/package/getPackageActivityHistory/${packageId}/${isChat}`, null, null, true);
    // else 
    //   return this.apiClient.get(`api/packageguestuser/getPackageActivityHistoryForCarrier/${packageId}/${isChat}`, null, null, true);
  }

  getPackageDetailActivityHistory(packageDetailId: number, isChat: number | null, guestUser: boolean = false) {    
    let url;
    if(guestUser == false)
    {
      url = `api/package/getPackageDetailActivityHistory/${packageDetailId}/${this.roleService.isCarrierUser}`;
      if (isChat !== null) {
        url += `/${isChat}`;
      }
    } else{
      url = `api/packageguestuser/getPackageDetailActivityHistoryForCarrier/${packageDetailId}/true`;
      if (isChat !== null) {
        url += `/${isChat}`;
      }
    }
    return this.apiClient.get(`${url}`, null, null, false);    
  }

  insertPackageActivityHistory(packageActivityHistory: ActivityHistory) {    
    if(packageActivityHistory.GuestUser == false)
      return this.apiClient.post(`api/package/insertPackageActivityHistory`, packageActivityHistory, null, true);
    else  
      return this.apiClient.post(`api/packageguestuser/insertPackageActivityHistoryForCarrier`, packageActivityHistory, null, true);
  }

  getContactByVerifyEmail(email:string) {    
    return this.apiClient.get(`api/packageguestuser/getContactByVerifyEmail/${email}`, null, null, true);
  }

  getActivationCodesByPackageId(packageId: number) {    
    return this.apiClient.get(`api/package/getActivationCodesByPackageId/${packageId}`, null, null, true);
  }

  deletePackageDetail(packageDetailId: number) {
    return this.apiClient.delete(`api/package/deletePackageDetail/${packageDetailId}`, null, null, true);
  }

  deletePackageDetailLineItem(packageDetailLineItemId: number) {
    return this.apiClient.delete(`api/package/deletePackageDetailLineItem/${packageDetailLineItemId}`, null, null, true);
  }

  fileUpload(carrierId, formData: FormData): Observable<any> {
    const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    return this.http.post(environment.baseUrl + `api/forms/fileUpload/${carrierId}`, formData, {
      headers: headers,
      reportProgress: true
    });
  }

  getFileUploadedFiles(carrierId: number) {
    return this.apiClient.get(`api/forms/getFileUploadedFiles/${carrierId}`, null, null, true);
  }

  getCarrierForms(carrierId: number) {
    return this.apiClient.get(`api/forms/getCarrierForms/${carrierId}`, null, null, true);
  }

  downloadAll(packageId, carrierUser: boolean = false, isGuestUser: boolean = false) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', 
      }),
      responseType: 'blob' as 'json', 
    };

    var controller = this.getControllerName(carrierUser, isGuestUser);
    var requestUrl = environment.baseUrl + `api/${controller}/downloadAll/${packageId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }

  insertParticipatingCarrier() {
    return this.apiClient.post(`api/packagecarrier/insertParticipatingCarrier`, null, null, false);
  }

  getParticipatingCarrierList(searchCarrierName: string): Observable<ParticipatingCarrier[]> {
    var participatingCarrier: ParticipatingCarrier = {
      carrierName: searchCarrierName
    } as ParticipatingCarrier
    return this.apiClient.post(`api/packagecarrier/getParticipatingCarrierList`, participatingCarrier, null, true);
  }

  getParticipatingCarrierForAgencyTenant(searchCarrierName: string): Observable<ParticipatingCarrier[]> {
    var participatingCarrier: ParticipatingCarrier = {
      carrierName: searchCarrierName
    } as ParticipatingCarrier
    return this.apiClient.post(`api/packagecarrier/getParticipatingCarrierForAgencyTenant`, participatingCarrier, null, true);
  }

  getParticipatingCarrierByTenantId(): Observable<ParticipatingCarrier> {
    return this.apiClient.get(`api/packagecarrier/getParticipatingCarrierByTenantId`, null, null, false);
  }

  getNotificationUsers(carrierId: number): Observable<ContactModel[]> {

    return this.apiClient.get(`api/package/getNotificationUsers/${carrierId}`, null, null, false);

  }

  saveNotificationUsers(request: any): Observable<any> {
    return this.apiClient.post(`api/package/notification-users`, request, null, false);
  }

  getTemplateByCarrierId(carrierId: number): Observable<PackageDetailHeader[]> {
    return this.apiClient.get(`api/package/getTemplateByCarrierId/${carrierId}`, null, null, false);
  }
  
  getPackagesForProducer(searchName: string = null, showLoader: boolean = true) {
    if (searchName != null) {
      return this.apiClient.get(`api/package/getPackagesForProducer/${searchName}`, null, null, showLoader);
    }
    else {
      return this.apiClient.get(`api/package/getPackagesForProducer`, null, null, showLoader);
    }
  }

  getPackageDetailReportForCarrier(searchPackageReport: SearchPackageReport) {
    return this.apiClient.post(`api/packagecarrier/getPackageDetailReport`, searchPackageReport, null, true);
  }

  getPackageDetailReport(searchPackageReport: SearchPackageReport) {
    return this.apiClient.post(`api/package/getPackageDetailReport`, searchPackageReport, null, true);
  }

  getExportPackageDetailReportForCarrier(searchPackageReport: SearchPackageReport) {
    return this.apiClient.export(`api/packagecarrier/getPackageDetailReport/Export`, searchPackageReport, null, true);
  }

  getExportPackageDetailReport(searchPackageReport: SearchPackageReport) {
    return this.apiClient.export(`api/package/getPackageDetailReport/Export`, searchPackageReport, null, true);
  }

  getAgencyListForCarrier() {
    return this.apiClient.get(`api/packagecarrier/getAgencyListForCarrier`, null, null, false);
  }

  getCarrierListForAgency() {
    return this.apiClient.get(`api/package/getCarrierListForAgency`, null, null, false);
  }

  denyPackageDetailRequest(updatePackageDetailStatusRequest: UpdatePackageDetailStatusRequest) {
    return this.apiClient.post(`api/packagecarrier/denyPackageDetailRequest`, updatePackageDetailStatusRequest, null, true);
  }

  getPackageRequestFees(carrierId, stateId, typeId) {
    return this.apiClient.get(`api/packagecarrier/getPackageRequestFees/${carrierId}/${stateId}/${typeId}`, null, null, false);
  }

  insertPackageRequestFee(packageRequestFee) {
    return this.apiClient.post(`api/packagecarrier/insertPackageRequestFee`, packageRequestFee, null, false);
  }

  updatePackageRequestFee(packageRequestFee) {
    return this.apiClient.post(`api/packagecarrier/updatePackageRequestFee`, packageRequestFee, null, false);
  }

  deletePackageRequestFee(packageRequestFee) {
    return this.apiClient.post(`api/packagecarrier/deletePackageRequestFee`, packageRequestFee, null, false);
  }

  getCarrierUserInfo(carrierUserId: number, packageDetailId: number) {
    return this.apiClient.get(`api/packagecarrier/getCarrierUserInfo/${carrierUserId}/${packageDetailId}`, null, null, false);
  }

   updatePackageDetailRequest(updatePackageDetailStatusRequest: UpdatePackageDetailStatusRequest) {
    return this.apiClient.post(`api/packagecarrier/updatePackageDetailRequest`, updatePackageDetailStatusRequest, null, true);
  }

  getDocumentTypeList(): Observable<DocumentType[]> {
    return this.apiClient.get(`api/package/getDocumentTypeList`, null, null, false);
  }

  
  insertCarrierDocumentTemplate(request: CarrierDocumentTemplate): Observable<number> {
    const formData = new FormData();

    formData.append('documentTypeId', request.documentTypeId.toString());
    formData.append('requiredFor', request.requiredFor.toString());
    formData.append('appliedTo', request.appliedTo.toString());
    formData.append('isRequired', request.isRequired.toString());
    formData.append('memo', request.memo || '');

    if (request.file) {
      formData.append('file', request.file[0].file, request.file[0].fileName);
    }

    const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    return this.apiClient.post(`api/package/insertCarrierDocumentTemplate`, formData, {
      headers: headers,
      reportProgress: true
    }, true);
  }

  updateCarrierDocumentTemplate(request: CarrierDocumentTemplate): Observable<void> {
    const formData = new FormData();

    formData.append('carrierDocumentTemplateId', request.carrierDocumentTemplateId.toString());
    formData.append('documentTypeId', request.documentTypeId.toString());
    formData.append('requiredFor', request.requiredFor.toString());
    formData.append('appliedTo', request.appliedTo.toString());
    formData.append('isRequired', request.isRequired.toString());
    formData.append('memo', request.memo || '');
    
    if(request.filePath){
      formData.append('fileName', request.fileName?.toString());
      formData.append('contentType', request.contentType?.toString());
      formData.append('filePath', request.filePath?.toString());
    }

    if (request.file) {
      formData.append('file', request.file[0].file, request.file[0].fileName);
    }

     const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    return this.apiClient.put(`api/package/updateCarrierDocumentTemplate`, formData, {
      headers: headers,
      reportProgress: true
    }, true);

  }

  getCarrierDocumentTemplateList(carrierId: number, isCarrierUser: boolean): Observable<CarrierDocumentTemplate[]> {
    if(isCarrierUser){
      return this.apiClient.get(`api/package/getCarrierDocumentTemplateList`, null, null, true);
    }else{
      return this.apiClient.get(`api/package/getCarrierDocumentTemplateListByCarrierId/${carrierId}`, null, null, true);
    }
    
  }

  getUserDocumentSubmission(userId: number = null, carrierId: number = 0): Observable<DocumentSubmission[]> {
    if (userId != null) {
      return this.apiClient.get(`api/package/getUserDocumentSubmissionForUser/${userId}/${carrierId}`, null, null, false);
    }
    else {
      return this.apiClient.get(`api/package/getUserDocumentSubmission/${carrierId}`, null, null, false);
    }
  }

  saveDocumentSubmission(request): Observable<number> {
    const formData = new FormData();

    formData.append('carrierDocumentTemplateId', request.carrierDocumentTemplateId.toString());
    request.userId ? formData.append('userId', request.userId.toString()) : '';

    if (request.file) {
      formData.append('file', request.file[0].file, request.file[0].fileName);
    }

    const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    return this.apiClient.post(`api/package/saveDocumentSubmission`, formData, {
      headers: headers,
      reportProgress: true
    }, true);
  }

  downloadCarrierDocumentTemplate(carrierDocumentTemplateId: number)
  {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    var requestUrl = environment.baseUrl + `api/package/downloadCarrierDocumentTemplate/${carrierDocumentTemplateId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }

  downloadDocumentSubmission(documentSubmissionId: number) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    var requestUrl = environment.baseUrl + `api/package/downloadDocumentSubmission/${documentSubmissionId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }

  deleteUserDocumentSubmission(documentSubmissionId: number){
    return this.apiClient.post(`api/package/deleteUserDocumentSubmission/${documentSubmissionId}`, null, null, true);
  }

  sendPackageSignatureRequired(packageId: number): Observable<number>{
    return this.apiClient.post(`api/package/sendPackageSignatureRequired/${packageId}`, null, null, true);
  }

  
  sendPackageDocumentRequired(packageId: number): Observable<number>{
    return this.apiClient.post(`api/package/sendPackageDocumentRequired/${packageId}`, null, null, true);
  }

  getUserDocumentSubmissionForPackage(carrieId: number, packageId: number): Observable<DocumentSubmission[]>{
    return this.apiClient.get(`api/package/getUserDocumentSubmissionForPackage/${carrieId}/${packageId}`, null, null, true);
  }

  getUserDocumentSubmissionForPackageDetail(carrieId: number, packageId: number, packageDetailId: number): Observable<DocumentSubmission[]> {
    return this.apiClient.get(`api/package/getUserDocumentSubmissionForPackageDetail/${carrieId}/${packageId}/${packageDetailId}`, null, null, true);
  }

  refreshPackageGrid(packageId: number){
    return this.apiClient.post(`api/package/refreshPackageGrid/${packageId}`, null, null, true);
  }

  regenratePackageAttachment(packageId: number){
    return this.apiClient.post(`api/package/regenratePackageAttachment/${packageId}`, null, null, true);
  }

  regenratePackageDetailAttachment(packageId: number, packageDetailId: number){
    return this.apiClient.post(`api/package/regenratePackageDetailAttachment/${packageId}/${packageDetailId}`, null, null, true);
  }
  
  getPackageRequiredStatus(packageIds: string): Observable<PackageRequiredStatus[]> {
    return this.apiClient.get(`api/package/getPackageRequiredStatus/${packageIds}`, null, null, false);
  }

  packageProcessStatus(packageId: number): Observable<PackageProcessStatus> {
    return this.apiClient.get(`api/package/packageProcessStatus/${packageId}`, null, null, false);
  }

  removePackageProcess(packageId: number){
    return this.apiClient.delete(`api/package/removePackageProcess/${packageId}`, null, null, false);
  }

  getNewContractingRequestCount(isCarrierUser: boolean = false): Observable<number>{
    return this.apiClient.get(`api/package/getNewContractingRequestCount/${isCarrierUser}`, null, null, false);
  }

  getPackageAttachmentsByUserId(packageId: number) {
    return this.apiClient.get(`api/package/getPackageAttachmentsByUserId/${packageId}`, null, null, false);
  }

  getPackageDetailStatusList() {
    return this.apiClient.get(`api/package/getPackageDetailStatusList`, null, null, false);
  }

  getPackageCompleteStatusForCarrier(packageIds: string): Observable<PackageRequiredStatus[]> {
    return this.apiClient.get(`api/packagecarrier/getPackageCompleteStatusForCarrier/${packageIds}`, null, null, false);
  }

  getPackageDetailLineItemsByDetailId(packageDetailId: number): Observable<PackageDetailLineItem[]> {
    return this.apiClient.get(`api/package/getPackageDetailLineItemsByDetailId/${packageDetailId}`, null, null, false);
  }
}
